module.exports = __webpack_public_path__ + "static/morgan-b0aeaef7588b3d90060de4d0e0769271.jpg";